import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Save } from "lucide-react";
import { toast } from "sonner";

const PAYMENT_FIELDS = [
  { k: "payment_bank_name", label: "Account / bank name" },
  { k: "payment_clabe", label: "CLABE (18 digits)" },
  { k: "payment_beneficiary", label: "Beneficiary shown to authors" },
];

const Label = ({ children }) => (
  <label className="block text-[10px] uppercase tracking-[0.2em] font-semibold mb-1.5">{children}</label>
);

export default function AdminSettings() {
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const save = async () => {
    const amount = Number(s.apc_amount_usd);
    toast.dismiss();
    if (!Number.isInteger(amount) || amount <= 0) { toast.error("Publication fee must be a positive whole number"); return; }
    try {
      const r = await api.put("/admin/settings", { ...s, apc_amount_usd: amount });
      setS(r.data);
      toast.success("Settings saved");
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };

  return (
    <div data-testid="admin-settings">
      <h1 className="font-serif text-3xl text-[#001F3F]">Journal Settings</h1>
      <div className="w-10 h-[2px] bg-[#2BA6A6] mt-3 mb-6"></div>

      <div className="bg-white border border-gray-200 p-6 grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
        {["journal_title", "journal_subtitle", "journal_abbreviation", "issn_electronic", "doi_prefix", "contact_email", "institution", "city_country", "website", "social_twitter", "social_linkedin"].map((k) => (
          <div key={k}>
            <Label>{k.replace(/_/g, " ")}</Label>
            <input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="w-full px-3 py-2 border border-gray-200 text-sm" data-testid={`setting-${k}`} />
          </div>
        ))}
      </div>

      <div className="bg-white border border-gray-200 p-6 mt-6 max-w-3xl" data-testid="settings-apc-section">
        <h2 className="font-serif text-xl text-[#001F3F]">Publication fee & payment details</h2>
        <p className="text-xs text-gray-500 mt-1 mb-4">Charged only after a manuscript is accepted. Updates the website, the submission form and the acceptance email automatically.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Publication fee (USD)</Label>
            <input type="number" min="1" step="1" value={s.apc_amount_usd ?? ""} onChange={(e) => setS({ ...s, apc_amount_usd: e.target.value })} className="w-full px-3 py-2 border border-gray-200 text-sm" data-testid="setting-apc_amount_usd" />
          </div>
          {PAYMENT_FIELDS.map(({ k, label }) => (
            <div key={k}>
              <Label>{label}</Label>
              <input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="w-full px-3 py-2 border border-gray-200 text-sm" data-testid={`setting-${k}`} />
            </div>
          ))}
        </div>
      </div>

      <button onClick={save} className="mt-4 bg-[#001F3F] text-white px-5 py-2 text-xs uppercase tracking-wider hover:bg-[#2BA6A6]" data-testid="save-settings"><Save className="w-3 h-3 inline mr-1" /> Save Settings</button>
    </div>
  );
}
